import { TableCell, TableRow, tableCellClasses } from "@mui/material";
import { styled } from "@mui/material/styles";
import {
  getApprovalAssignmentsAction,
  deleteApprovalAssignmentAction,
  getRemittanceDeliveriesAction,
  deleteRemittanceDeliveryAction,
  getLoanApplicationAction,
  updateLoanApplicationAction,
  getNotesAction,
  deleteNoteAction,
  getLoanProcessAction,
  deleteLoanProcessAction,
  getReversalLoanProcessAction,
  getReversalAmortizationV2Action,
  getReversalDailyOperationV2Action,
  getReversalReceiptAction,
  getReversalEmiReceiptAction,
  getReversalDailyProcessAction,
  getReversalLoanAuditAction,
  getReversalLoanWorkflowAction,
  getReversalDailyStatusMessengerAction,
  getReversalLoanPaymentAuditAction,
  getReversalMessengerDepositAction,
  getReversalMessengerCashLimitLogAction,
  deleteReversalReceiptAction,
  deleteReversalEmiReceiptAction,
  deleteReversalDailyOperationV2Action,
  deleteReversalDailyProcessAction,
  deleteReversalLoanWorkflowAction,
  deleteReversalMessengerDepositAction,
  deleteReversalMessengerCashLimitLogAction,
  updateReversalLoanProcessAction,
  updateReversalAmortizationV2Action,
  updateReversalDailyStatusMessengerAction,
  updateReversalLoanPaymentAuditAction,
  updateReversalMessengerDepositAction,
  updateReversalMessengerCashLimitLogAction,
  insertReversalLoanAuditAction,
  getReversalMinimartAction,
  updateReversalMinimartAction,
  getReversalMinimartLogAction,
  deleteReversalMinimartLogAction,
  updateReversalMinimartLogAction,
  getReversalAdditionalExpenseFeeReceiptAction,
  deleteReversalAdditionalExpenseFeeReceiptAction,
  updateReversalAdditionalExpenseFeeReceiptAction,
  getReversalAdditionalExpenseFeeReceiptAuditAction,
  deleteReversalAdditionalExpenseFeeReceiptAuditAction,
  getReversalAdministrativeExpenseFeeReceiptAction,
  deleteReversalAdministrativeExpenseFeeReceiptAction,
  getReversalDailyStatusMessengerAdditionalExpenseAction,
  updateReversalDailyStatusMessengerAdditionalExpenseAction,
  getReversalCollectionTransferReceiptMappingAction,
  deleteReversalCollectionTransferReceiptMappingAction,
  updateReversalCollectionTransferReceiptMappingAction,
} from "./DatabaseTableAction";
import { API } from "../../constants/APIConstants";

export const DATABASE_TABLES_TABS = [
    { key: "loanApplication", label: "loan_application", value: "LOAN_APPLICATION" },
    { key: "loanProcess", label: "loan_process", value: "LOAN_PROCESS" },
    { key: "dailyOperationV2", label: "daily_operation_v2", value: "DAILY_OPERATION_V2" },
    { key: "amortizationV2", label: "amortization_v2", value: "AMORTIZATION_V2" },
    { key: "receipt", label: "receipt", value: "RECEIPT" },
    { key: "emiReceipts", label: "emi_receipts", value: "EMI_RECEIPTS" },
];

export const DATABASE_TABLES_NAMES = {
    LOAN_APPLICATION: "LOAN_APPLICATION",
    LOAN_PROCESS: "LOAN_PROCESS",
    DAILY_OPERATION_V2: "DAILY_OPERATION_V2",
    AMORTIZATION_V2: "AMORTIZATION_V2",
    RECEIPT: "RECEIPT",
    EMI_RECEIPTS: "EMI_RECEIPTS"
};
export const LOAN_APPLICATION_COLUMNS = [
    { key: "income", label: "income" },
    { key: "meta_latitude", label: "meta_latitude" },
    { key: "evidence", label: "evidence" },
    { key: "isactive", label: "isactive" },
    { key: "auto_analysis", label: "auto_analysis" },
    { key: "meta_longitude", label: "meta_longitude" },
    { key: "intiated_from", label: "intiated_from" },
    { key: "disbursed_date", label: "disbursed_date" },
    { key: "application_id", label: "application_id" },
    { key: "loan_info", label: "loan_info" },
    { key: "meta_verification_type", label: "meta_verification_type" },
    { key: "updated_at", label: "updated_at" },
    { key: "is_form_filled", label: "is_form_filled" },
    { key: "status", label: "status" },
    { key: "minimart_id", label: "minimart_id" },
    { key: "conciliation_type", label: "conciliation_type" },
    { key: "basic_info", label: "basic_info" },
    { key: "reminder", label: "reminder" },
    { key: "type", label: "type" },
    { key: "site_visit", label: "site_visit" },
    { key: "created_at", label: "created_at" },
    { key: "created_by", label: "created_by" },
    { key: "additional_info", label: "additional_info" },
    { key: "is_cedula_matching", label: "is_cedula_matching" },
    { key: "order_id", label: "order_id" },
    { key: "expenses", label: "expenses" }
];



export const LOAN_PROCESS_COLUMNS = [
    { key: "id", label: "id" },
    { key: "application_id", label: "application_id" },
    { key: "amount", label: "amount" },
    { key: "term", label: "term" },
    { key: "frequency", label: "frequency" },
    { key: "rate", label: "rate" },
    { key: "emi", label: "emi" },
    { key: "late_fees_id", label: "late_fees_id" },
    { key: "status_id", label: "status_id" },
    { key: "grace_period_id", label: "grace_period_id" },
    { key: "early_payment_id", label: "early_payment_id" },
    { key: "provision_id", label: "provision_id" },
    { key: "late_fees", label: "late_fees" },
    { key: "status", label: "status" },
    { key: "grace_period", label: "grace_period" },
    { key: "early_payment", label: "early_payment" },
    { key: "provision_type", label: "provision_type" },
    { key: "provision_amount", label: "provision_amount" },
    { key: "arrears_in_days", label: "arrears_in_days" },
    { key: "arrears_in_days_old", label: "arrears_in_days_old" },
    { key: "is_new_loan", label: "is_new_loan" },
    { key: "amount_to_collect", label: "amount_to_collect" },
    { key: "unpaid_capital", label: "unpaid_capital" },
    { key: "unpaid_interest", label: "unpaid_interest" },
    { key: "unpaid_late_fees", label: "unpaid_late_fees" },
    { key: "past_due_balance", label: "past_due_balance" },
    { key: "current_installment_index", label: "current_installment_index" },
    { key: "is_active_plan", label: "is_active_plan" },
    { key: "disbursed_date", label: "disbursed_date" },
    { key: "created_at", label: "created_at" },
    { key: "updated_at", label: "updated_at" }
];

export const DAILY_OPERATIONS_V2_COLUMNS = [
    { key: "id", label: "id" },
    { key: "loan_process_id", label: "loan_process_id" },
    { key: "installment_index", label: "installment_index" },
    { key: "outof", label: "outof" },
    { key: "capital_paid", label: "capital_paid" },
    { key: "interest_paid", label: "interest_paid" },
    { key: "late_fees_paid", label: "late_fees_paid" },
    { key: "past_due_capital", label: "past_due_capital" },
    { key: "past_due_interest", label: "past_due_interest" },
    { key: "past_due_late_fees", label: "past_due_late_fees" },
    { key: "remaining_capital", label: "remaining_capital" },
    { key: "remaining_interest", label: "remaining_interest" },
    { key: "remaining_late_fees", label: "remaining_late_fees" },
    { key: "amount_paid", label: "amount_paid" },
    { key: "type", label: "type" },
    { key: "payment_type", label: "payment_type" },
    { key: "balance_to_date", label: "balance_to_date" },
    { key: "past_due_balance", label: "past_due_balance" },
    { key: "reference_date", label: "reference_date" },
    { key: "created_at", label: "created_at" },
    { key: "updated_at", label: "updated_at" }
];

export const AMORTIZATION_V2_COLUMNS = [
    {key: "id", label: "id" },
    { key: "loan_process_id", label: "loan_process_id", },
    { key: "installment_index", label: "installment_index" },
    { key: "outof", label: "outof" },
    { key: "principle", label: "principle" },
    { key: "interest", label: "interest" },
    { key: "late_fees", label: "late_fees" },
    { key: "penalties", label: "penalties" },
    { key: "amount_to_be_collected", label: "amount_to_be_collected" },
    { key: "amount_collected", label: "amount_collected" },
    { key: "status", label: "status" },
    { key: "days_past_due", label: "days_past_due" },
    { key: "payment_delayed_by", label: "payment_delayed_by" },
    { key: "payment_dates", label: "payment_dates" },
    { key: "note_id", label: "note_id" },
    { key: "due_date", label: "due_date" },
    { key: "created_at", label: "created_at" },
    { key: "updated_at", label: "updated_at" }
];
export const EMI_RECEIPT_COLUMNS = [
    { key: "id", label: "id" },
     {key: "receipt_id", label: "receipt_id" },
    { key: "transaction_id", label: "transaction_id" },
    { key: "payment_source", label: "payment_source" },
    { key: "payment_mode", label: "payment_mode" },
    { key: "is_conciliated", label: "is_conciliated" },
    { key: "is_conciliated_with_promotion", label: "is_conciliated_with_promotion" },
    { key: "amortization_id", label: "amortization_id" },
    { key: "amortizationV2_id", label: "amortizationV2_id" },
    { key: "emi_transfer_receipt_id", label: "emi_transfer_receipt_id" },
    { key: "conciliation_receipt_id", label: "conciliation_receipt_id" },
    { key: "created_at", label: "created_at" },
    { key: "updated_at", label: "updated_at" }
];

export const RECEIPT_COLUMNS = [
     {key: "id", label: "id" },
    { key: "ref_id", label: "ref_id" },
    { key: "type", label: "type" },
    { key: "status", label: "status" },
    { key: "data", label: "data" },
    { key: "data_temp", label: "data_temp" },
    { key: "created_at", label: "created_at" },
    { key: "updated_at", label: "updated_at" }
];

// ── Duplicate Entry Management ────────────────────────────────────────────────


export const formatValue = (val) => {
  if (val === null || val === undefined) return "-";
  if (typeof val === "object") return JSON.stringify(val);
  return String(val);
};


export const getMaxId = (rows, idField) => {
  const field = idField
  return rows.reduce(
    (max, row) => (Number(row[field]) > Number(max) ? row[field] : max),
    rows[0][field]
  );
};

// Enum option lists mirror the backend LoanConstants enums.
export const LOAN_APPLICATION_ENUM_OPTIONS = {
  loanStatus: [
    "CREATED", "SUBMITTED", "INCOMPLETE", "PENDING", "ANALYSIS", "APPROVED", "REJECTED_BY_SYSTEM",
    "DISMISSED", "INPROCESS", "READY_TO_SIGN", "READY_TO_APPROVE_CREDIT_LIMIT", "DISBURSED",
    "READY_TO_APPROVE", "INPROCESS_ANALYSIS", "REJECTED_BY_ANALYST", "INPROCESS_OPERATIONS",
    "INPROCESS_ACCOUNTS", "READY_TO_DISBURSE", "READY_FOR_COLLECTION", "REJECTED",
    "REJECTED_BY_OPERATIONS_OFFICER", "CLOSED",
  ],
  loanType: [
    "FACTORING", "EXTERNAL_FACTORING", "TU_PRESTAMO", "CASH_TOPUP", "PREMIUM_CASH_TOPUP", "CONSUMER",
    "MOTORCYCLE", "FAST_CASH", "BUSINESS_IMPROVEMENT", "CAR", "PROPERTY", "PERSONAL_LOAN",
  ],
  initiatedFrom: ["TPRESTA", "CORE", "CI", "WEB"],
  conciliationType: ["NON_CONCILIATED", "CONCILIATED"],
};

// Columns the data administrator may edit on loan_application. The primary key, the timestamps and
// the JSON columns (loan_info, basic_info …) are intentionally left out.
export const LOAN_APPLICATION_EDITABLE_FIELDS = [
  { key: "status", type: "enum", options: LOAN_APPLICATION_ENUM_OPTIONS.loanStatus },
  { key: "type", type: "enum", options: LOAN_APPLICATION_ENUM_OPTIONS.loanType },
  { key: "intiated_from", type: "enum", options: LOAN_APPLICATION_ENUM_OPTIONS.initiatedFrom },
  { key: "conciliation_type", type: "enum", options: LOAN_APPLICATION_ENUM_OPTIONS.conciliationType },
  { key: "minimart_id", type: "number" },
  { key: "order_id", type: "text" },
  { key: "is_form_filled", type: "number" },
  { key: "isactive", type: "number" },
  { key: "auto_analysis", type: "number" },
  { key: "is_cedula_matching", type: "number" },
  { key: "reminder", type: "number" },
  { key: "disbursed_date", type: "date" },
  { key: "created_by", type: "number" },
];

export const DUPLICATE_TABS = [
  { key: "approvalAssignment", label: "approval_assignment",  searchParam: "applicationId", multi: true,  idField: "id"             },
  { key: "remittanceDelivery", label: "remittance_delivery", searchParam: "applicationId", multi: true,  idField: "id"             },
  { key: "loanApplication",    label: "loan_application",      searchParam: "applicationId", multi: false, idField: "application_id",
    editableFields: LOAN_APPLICATION_EDITABLE_FIELDS },
  { key: "loanProcess",        label: "loan_process",          searchParam: "applicationId", multi: true,  idField: "id"             },
  // notes are deleted row by row (no "max id" duplicate rule applies to them)
  { key: "notes",              label: "notes",                 searchParam: "applicationId", multi: true,  idField: "id", rowDelete: true },
];

export const fetchByTab = (tabKey, searchValue, callBack) => {
  switch (tabKey) {
    case "approvalAssignment": return getApprovalAssignmentsAction(searchValue, callBack);
    case "remittanceDelivery": return getRemittanceDeliveriesAction(searchValue, callBack);
    case "loanApplication":    return getLoanApplicationAction(searchValue, callBack);
    case "loanProcess":        return getLoanProcessAction(searchValue, callBack);
    case "notes":              return getNotesAction(searchValue, callBack);
    default: break;
  }
};

export const deleteByTab = (tabKey, id, callBack) => {
  switch (tabKey) {
    case "approvalAssignment": return deleteApprovalAssignmentAction(id, callBack);
    case "remittanceDelivery": return deleteRemittanceDeliveryAction(id, callBack);
    case "loanProcess":        return deleteLoanProcessAction(id, callBack);
    case "notes":              return deleteNoteAction(id, callBack);
    default: break;
  }

};

export const updateByTab = (tabKey, id, body, callBack) => {
  switch (tabKey) {
    case "loanApplication": return updateLoanApplicationAction(id, body, callBack);
    default: break;
  }
};

export const StyledHeadCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 11,
    backgroundColor: "#d5d5d5",
    color: theme.palette.common.black,
    fontWeight: "bold",
    borderRight: "1px solid #bbb",
    padding: "8px 10px",
    position: "sticky",
    top: 0,
    zIndex: 1,
    whiteSpace: "nowrap",
  },
}));

export const StyledBodyCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
    borderRight: "1px solid #bbb",
    padding: "6px 10px",
    whiteSpace: "normal",
    wordBreak: "break-word",
    maxWidth: 200,
  },
}));

export const StyledRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(even)": { backgroundColor: theme.palette.action.hover },
}));

export const REVERSAL_ENUM_OPTIONS = {
  installmentStatus: ["PAID", "DUE", "PAST_DUE", "PARTIALY_PAID"],
  loanCategory: ["ACTIVE", "LEGAL", "W_OFF", "CLOSED", "INACTIVE", "DISAPPEARED", "PAYMENT_AGREEMENT"],
  provisionType: ["A", "B", "C", "D", "D1", "D2", "E"],
  loanAuditFrequency: ["DAILY", "MONTHLY"],
  depositStatus: ["NOT_VERIFIED", "VERIFIED", "DISCREPANCY"],
  paymentMode: ["DEPOSIT", "TRANSFER", "CASH"],
  paymentSource: ["WEB", "MOBILE"],
  additionalExpenseEntryType: ["APPLIED", "REVERTED", "PAID", "PAYMENT_REVERTED", "PARTIALLY_REVERTED"],
};

export const PAYMENT_REVERSAL_TABS = [
    {
    key: "emiReceipt", label: "emi_receipt", group: "A", note: "reversalNoteEmiReceipt",
    searchParams: [{ name: "loanProcessId", type: "number" }],
    ops: { del: true }, idField: "id",
  },
  {
    key: "receipt", label: "receipt", group: "A", note: "reversalNoteReceipt",
    searchParams: [{ name: "loanProcessId", type: "number" }],
    ops: { del: true }, idField: "id",
  },
  {
    key: "collectionTransferReceiptMapping", label: "collection_transfer_receipt_mapping", group: "A", note: "reversalNoteCollectionTransferReceiptMapping",
    searchParams: [{ name: "loanProcessId", type: "number" }],
    ops: { del: true, update: true }, idField: "id",
    editableFields: [
      { key: "bank_id", type: "number" },
      { key: "emi_transfer_receipt_id", type: "number" },
      { key: "payment_mode", type: "enum", options: REVERSAL_ENUM_OPTIONS.paymentMode },
      { key: "payment_source", type: "enum", options: REVERSAL_ENUM_OPTIONS.paymentSource },
    ],
  },
  {
    key: "amortizationV2", label: "amortization_v2", group: "A", note: "reversalNoteAmortizationV2",
    searchParams: [{ name: "loanProcessId", type: "number" }],
    ops: { update: true }, idField: "id",
    editableFields: [
      { key: "interest", type: "number" },
      { key: "penalties", type: "number" },
      { key: "principle", type: "number" },
      { key: "late_fees", type: "number" },
      { key: "amount_to_be_collected", type: "number" },
      { key: "amount_collected", type: "number" },
      { key: "status", type: "enum", options: REVERSAL_ENUM_OPTIONS.installmentStatus },
      { key: "payment_dates", type: "text" },
    ],
  },
  {
    key: "dailyOperationV2", label: "daily_operation_v2", group: "A", note: "reversalNoteDailyOperationV2",
    searchParams: [{ name: "loanProcessId", type: "number" }],
    ops: { del: true }, idField: "id",
  },
  {
    key: "dailyProcess", label: "daily_process", group: "A", note: "reversalNoteDailyProcess",
    searchParams: [{ name: "loanProcessId", type: "number" }],
    ops: { del: true }, idField: "id",
  },
  {
    key: "loanProcess", label: "loan_process", group: "A", note: "reversalNoteLoanProcess",
    searchParams: [{ name: "loanProcessId", type: "number" }],
    ops: { update: true }, idField: "id",
    editableFields: [
      { key: "status", type: "enum", options: REVERSAL_ENUM_OPTIONS.loanCategory },
      { key: "amount_to_collect", type: "number" },
      { key: "closed_date", type: "date" },
      { key: "past_due_balance", type: "number" },
      { key: "unpaid_late_fees", type: "number" },
      { key: "unpaid_interest", type: "number" },
      { key: "unpaid_capital", type: "number" },
    ],
  },
  {
    key: "minimart", label: "minimart", group: "B", note: "reversalNoteMinimart",
    searchParams: [{ name: "minimartId", type: "number" }],
    ops: { update: true }, idField: "id",
    editableFields: [
      { key: "used_credit_limit", type: "number" },
    ],
  },
  {
    key: "minimartLog", label: "minimart_log", group: "B", note: "reversalNoteMinimartLog",
    searchParams: [{ name: "minimartId", type: "number" }],
    ops: { del: true }, idField: "id",
  },
  {
    key: "dailyStatusMessenger", label: "daily_status_messenger", group: "B", note: "reversalNoteDailyStatusMessenger",
    searchParams: [{ name: "dailyStatusMessengerId", type: "number" }],
    ops: { update: true }, idField: "id",
    editableFields: [
      { key: "emi_collected", type: "number" },
      { key: "pending_administrative_expense", type: "number" },
      { key: "collected_administrative_expense", type: "number" },
      { key: "collected_administrative_expense_collected_cash", type: "number" },
      { key: "collected_administrative_expense_collected_transfer", type: "number" },
      { key: "collected_administrative_expense_collected_deposit", type: "number" },
      { key: "todays_emi", type: "number" },
      { key: "amount_collected", type: "number" },
      { key: "amount_collected_cash", type: "number" },
      { key: "amount_collected_transfer", type: "number" },
      { key: "amount_collected_deposit", type: "number" },
      { key: "amount_deposited", type: "number" },
      { key: "amount_verified", type: "number" },
    ],
  },
  {
    key: "dailyStatusMessengerAdditionalExpense", label: "daily_status_messenger_additional_expense", group: "B", note: "reversalNoteDailyStatusMessengerAdditionalExpense",
    searchParams: [{ name: "dailyStatusMessengerId", type: "number" }],
    ops: { update: true }, idField: "id",
    editableFields: [
      { key: "pending_additional_expense", type: "number" },
      { key: "collected_additional_expense", type: "number" },
      { key: "collected_additional_expense_collected_cash", type: "number" },
      { key: "collected_additional_expense_collected_transfer", type: "number" },
      { key: "collected_additional_expense_collected_deposit", type: "number" },
    ],
  },
  {
    key: "loanPaymentAudit", label: "loan_payment_audit", group: "B", note: "reversalNoteLoanPaymentAudit",
    searchParams: [{ name: "branchId", type: "number" }, { name: "month", type: "month" }],
    ops: { update: true }, idField: "id",
    editableFields: [
      { key: "regular_capital_paid", type: "number" },
      { key: "conciliated_capital_paid", type: "number" },
      { key: "regular_interest_paid", type: "number" },
      { key: "conciliated_interest_paid", type: "number" },
      { key: "regular_lates_fees_paid", type: "number" },
      { key: "conciliated_lates_fees_paid", type: "number" },
    ],
  },
  {
    key: "loanAudit", label: "loan_audit", group: "A", note: "reversalNoteLoanAudit",
    searchParams: [{ name: "loanProcessId", type: "number" }],
    ops: { insert: true }, idField: "id",
    insertFields: [
      { key: "status", type: "enum", options: REVERSAL_ENUM_OPTIONS.loanCategory },
      { key: "provisionType", type: "enum", options: REVERSAL_ENUM_OPTIONS.provisionType },
      { key: "provisionAmount", type: "number" },
      { key: "type", type: "enum", options: REVERSAL_ENUM_OPTIONS.loanAuditFrequency },
    ],
  },
  {
    key: "loanWorkflow", label: "loan_workflow", group: "A", note: "reversalNoteLoanWorkflow",
    searchParams: [{ name: "loanProcessId", type: "number" }],
    ops: { del: true }, idField: "id",
  },
  {
    key: "messengerCashLimitLog", label: "messenger_cash_limit_log", group: "B", note: "reversalNoteMessengerCashLimitLog",
    searchParams: [{ name: "messengerDepositId", type: "number" }],
    ops: { del: true }, idField: "id",
  },
  {
    key: "messengerDeposit", label: "messenger_deposit", group: "B", note: "reversalNoteMessengerDeposit",
    searchParams: [{ name: "messengerDepositId", type: "number" }],
    ops: { del: true, update: true }, idField: "id",
    editableFields: [
      { key: "amount_deposited", type: "number" },
    ],
  },
  {
    key: "additionalExpenseFeeReceipt", label: "additional_expense_fee_receipt", group: "A", note: "reversalNoteAdditionalExpenseFeeReceipt",
    searchParams: [{ name: "loanProcessId", type: "number" }],
    ops: { del: true, update: true }, idField: "id",
    editableFields: [
      { key: "entry_type", type: "enum", options: REVERSAL_ENUM_OPTIONS.additionalExpenseEntryType },
      { key: "pending_amount", type: "number" },
      { key: "amount_paid", type: "number" },
      { key: "receipt_id", type: "number" },
      { key: "transfer_receipt_id", type: "number" },
      { key: "payment_mode", type: "enum", options: REVERSAL_ENUM_OPTIONS.paymentMode },
      { key: "payment_source", type: "enum", options: REVERSAL_ENUM_OPTIONS.paymentSource },
    ],
  },
  {
    key: "additionalExpenseFeeReceiptAudit", label: "additional_expense_fee_receipt_audit", group: "A", note: "reversalNoteAdditionalExpenseFeeReceiptAudit",
    searchParams: [{ name: "loanProcessId", type: "number" }],
    ops: { del: true }, idField: "id",
  },
  {
    key: "administrativeExpenseFeeReceipt", label: "administrative_expense_fee_receipt", group: "A", note: "reversalNoteAdministrativeExpenseFeeReceipt",
    searchParams: [{ name: "loanProcessId", type: "number" }],
    ops: { del: true }, idField: "id",
  },
];

export const fetchReversalByTab = (tab, values, callBack) => {
  switch (tab.key) {
    case "loanProcess": return getReversalLoanProcessAction(values.loanProcessId, callBack);
    case "amortizationV2": return getReversalAmortizationV2Action(values.loanProcessId, callBack);
    case "dailyOperationV2": return getReversalDailyOperationV2Action(values.loanProcessId, callBack);
    case "dailyProcess": return getReversalDailyProcessAction(values.loanProcessId, callBack);
    case "receipt": return getReversalReceiptAction(values.loanProcessId, callBack);
    case "emiReceipt": return getReversalEmiReceiptAction(values.loanProcessId, callBack);
    case "loanAudit": return getReversalLoanAuditAction(values.loanProcessId, callBack);
    case "loanWorkflow": return getReversalLoanWorkflowAction(values.loanProcessId, callBack);
    case "dailyStatusMessenger": return getReversalDailyStatusMessengerAction(values.dailyStatusMessengerId, callBack);
    case "loanPaymentAudit": return getReversalLoanPaymentAuditAction(values.branchId, values.month, callBack);
    case "messengerDeposit": return getReversalMessengerDepositAction(values.messengerDepositId, callBack);
    case "messengerCashLimitLog": return getReversalMessengerCashLimitLogAction(values.messengerDepositId, callBack);
    case "minimart": return getReversalMinimartAction(values.minimartId, callBack);
    case "minimartLog": return getReversalMinimartLogAction(values.minimartId, callBack);
    case "additionalExpenseFeeReceipt": return getReversalAdditionalExpenseFeeReceiptAction(values.loanProcessId, callBack);
    case "additionalExpenseFeeReceiptAudit": return getReversalAdditionalExpenseFeeReceiptAuditAction(values.loanProcessId, callBack);
    case "administrativeExpenseFeeReceipt": return getReversalAdministrativeExpenseFeeReceiptAction(values.loanProcessId, callBack);
    case "dailyStatusMessengerAdditionalExpense": return getReversalDailyStatusMessengerAdditionalExpenseAction(values.dailyStatusMessengerId, callBack);
    case "collectionTransferReceiptMapping": return getReversalCollectionTransferReceiptMappingAction(values.loanProcessId, callBack);
    default: break;
  }
};

export const deleteReversalByTab = (tabKey, id, callBack) => {
  switch (tabKey) {
    case "dailyOperationV2": return deleteReversalDailyOperationV2Action(id, callBack);
    case "dailyProcess": return deleteReversalDailyProcessAction(id, callBack);
    case "receipt": return deleteReversalReceiptAction(id, callBack);
    case "emiReceipt": return deleteReversalEmiReceiptAction(id, callBack);
    case "loanWorkflow": return deleteReversalLoanWorkflowAction(id, callBack);
    case "messengerDeposit": return deleteReversalMessengerDepositAction(id, callBack);
    case "messengerCashLimitLog": return deleteReversalMessengerCashLimitLogAction(id, callBack);
    case "minimartLog": return deleteReversalMinimartLogAction(id, callBack);
    case "additionalExpenseFeeReceipt": return deleteReversalAdditionalExpenseFeeReceiptAction(id, callBack);
    case "additionalExpenseFeeReceiptAudit": return deleteReversalAdditionalExpenseFeeReceiptAuditAction(id, callBack);
    case "administrativeExpenseFeeReceipt": return deleteReversalAdministrativeExpenseFeeReceiptAction(id, callBack);
    case "collectionTransferReceiptMapping": return deleteReversalCollectionTransferReceiptMappingAction(id, callBack);
    default: break;
  }
};

export const updateReversalByTab = (tabKey, id, body, callBack) => {
  switch (tabKey) {
    case "loanProcess": return updateReversalLoanProcessAction(id, body, callBack);
    case "amortizationV2": return updateReversalAmortizationV2Action(id, body, callBack);
    case "dailyStatusMessenger": return updateReversalDailyStatusMessengerAction(id, body, callBack);
    case "loanPaymentAudit": return updateReversalLoanPaymentAuditAction(id, body, callBack);
    case "messengerDeposit": return updateReversalMessengerDepositAction(id, body, callBack);
    case "messengerCashLimitLog": return updateReversalMessengerCashLimitLogAction(id, body, callBack);
    case "minimart": return updateReversalMinimartAction(id, body, callBack);
    case "minimartLog": return updateReversalMinimartLogAction(id, body, callBack);
    case "additionalExpenseFeeReceipt": return updateReversalAdditionalExpenseFeeReceiptAction(id, body, callBack);
    case "dailyStatusMessengerAdditionalExpense": return updateReversalDailyStatusMessengerAdditionalExpenseAction(id, body, callBack);
    case "collectionTransferReceiptMapping": return updateReversalCollectionTransferReceiptMappingAction(id, body, callBack);
    default: break;
  }
};

export const insertReversalByTab = (tabKey, body, callBack) => {
  switch (tabKey) {
    case "loanAudit": return insertReversalLoanAuditAction(body, callBack);
    default: break;
  }
};


export const BULK_UPLOAD_TABS = [
  {
    key: "minimart",
    label: "bulkUploadMinimartTab",
    validateUrl: API.bulkUploadMinimartValidate,
    uploadUrl: API.bulkUploadMinimart,
    processPendingUrl: API.bulkUploadMinimartProcessPending,
    headers: [
      "Minimart Name", "City", "Sector", "Street", "Number", "Reference",
      "Owner Name", "Admin Name", "Telephone", "Alternate Telephone",
      "Email", "Cedula", "Seller Zone",
    ],
  },
  {
    key: "microCreditClient",
    label: "bulkUploadMicroCreditClientTab",
    validateUrl: API.bulkUploadMicroCreditClientValidate,
    uploadUrl: API.bulkUploadMicroCreditClient,
    processPendingUrl: API.bulkUploadMicroCreditClientProcessPending,
    headers: [
      "minimart_name", "city", "sector", "street", "number", "reference",
      "owner_name", "telephone", "cedula_number", "seller_zone",
    ],
  },
];

export const ANALYTICS_REPORT_EARLIEST_YEAR = 2015;
export const ANALYTICS_REPORT_MAX_RANGE_DAYS = 3660;
export const ANALYTICS_REPORT_MAX_DAY_BUCKETS = 400;
export const ANALYTICS_REPORT_GRANULARITIES = ["AUTO", "DAY", "MONTH"];
export const ANALYTICS_CHART_CONFIG = [
  {
    id: "monthlyLoans",
    group: "volume",
    title: "chart_monthlyLoans",
    dataset: "disbursed",
    xKey: "month",
    series: [
      { key: "loans_disbursed", label: "chart_loansDisbursed" },
    ],
    types: ["bar", "line", "area"],
    defaultType: "bar",
  },
  {
    id: "disbursedAmount",
    group: "volume",
    title: "chart_disbursedAmount",
    dataset: "disbursed",
    xKey: "month",
    series: [
      { key: "disbursed_amount", label: "chart_disbursedAmount" },
    ],
    types: ["bar", "line", "area"],
    defaultType: "line",
    money: true,
  },
  {
    id: "collections",
    group: "collections",
    title: "chart_collections",
    subtitle: "chart_collectionsSubtitle",
    dataset: "collections",
    xKey: "month",
    series: [
      { key: "capital_collected", label: "chart_capital" },
      { key: "interest_collected", label: "chart_interest" },
      { key: "late_fees_collected", label: "chart_lateFees" },
    ],
    types: ["stackedBar", "stackedArea", "line"],
    defaultType: "stackedBar",
    money: true,
  },
  {
    id: "revenue",
    group: "collections",
    title: "chart_revenue",
    dataset: "revenue",
    xKey: "month",
    series: [
      { key: "interest_collected", label: "chart_interest" },
      { key: "late_fees_collected", label: "chart_lateFees" },
      { key: "expense_collected", label: "chart_expenses" },
    ],
    types: ["stackedBar", "stackedArea", "line"],
    defaultType: "stackedArea",
    money: true,
  },
  {
    id: "activeLoans",
    group: "portfolio",
    title: "chart_activeLoans",
    subtitle: "chart_activeLoansSubtitle",
    dataset: "activeMonthly",
    xKey: "month",
    series: [{ key: "active_loans", label: "chart_activeLoans" }],
    types: ["line", "area", "bar"],
    defaultType: "line",
  },
  {
    id: "loanType",
    group: "portfolio",
    title: "chart_loanType",
    dataset: "loanType",
    xKey: "loan_type",
    series: [{ key: "loan_count", label: "chart_loans" }],
    aggregateBy: "loan_type",
    types: ["horizontalBar", "pie"],
    defaultType: "horizontalBar",
    height: 340,
  },
  {
    id: "loanSource",
    group: "portfolio",
    title: "chart_loanSource",
    dataset: "source",
    xKey: "loan_source",
    series: [{ key: "loan_count", label: "chart_loans" }],
    aggregateBy: "loan_source",
    types: ["pie", "horizontalBar"],
    defaultType: "pie",
  },
  {
    id: "paymentMode",
    group: "collections",
    title: "chart_paymentMode",
    dataset: "paymentMode",
    xKey: "payment_mode",
    series: [{ key: "amount_collected", label: "chart_amountCollected" }],
    aggregateBy: "payment_mode",
    types: ["pie", "horizontalBar"],
    defaultType: "pie",
    money: true,
  },
  {
    id: "expenseType",
    group: "collections",
    title: "chart_expenseType",
    dataset: "expensesByType",
    xKey: "expense_type",
    series: [{ key: "amount_collected", label: "chart_amountCollected" }],
    aggregateBy: "expense_type",
    types: ["horizontalBar", "pie"],
    defaultType: "horizontalBar",
    money: true,
    height: 340,
  },
  {
    id: "freqTerm",
    group: "portfolio",
    title: "chart_freqTerm",
    subtitle: "chart_snapshotSubtitle",
    dataset: "freqTerm",
    xKey: "frequencyTerm",
    series: [{ key: "active_loans", label: "chart_activeLoans" }],
    types: ["horizontalBar"],
    defaultType: "horizontalBar",
    height: 360,
  },
  {
    id: "negotiations",
    group: "portfolio",
    title: "chart_negotiations",
    dataset: "negotiations",
    xKey: "minimart_level",
    series: [{ key: "negotiation_count", label: "chart_negotiations" }],
    aggregateBy: "minimart_level",
    types: ["horizontalBar", "pie"],
    defaultType: "horizontalBar",
  },
  {
    id: "arrears",
    group: "risk",
    title: "chart_arrears",
    subtitle: "chart_snapshotSubtitle",
    dataset: "arrearsBuckets",
    xKey: "arrears_bucket",
    series: [{ key: "outstanding_principal", label: "chart_outstanding" }],
    types: ["horizontalBar", "bar"],
    defaultType: "horizontalBar",
    money: true,
    ordinal: true,
  },
  {
    id: "provisionMix",
    group: "risk",
    title: "chart_provisionMix",
    subtitle: "chart_snapshotSubtitle",
    dataset: "provisionMix",
    xKey: "provision_grade",
    series: [{ key: "outstanding_principal", label: "chart_outstanding" }],
    types: ["bar", "horizontalBar"],
    defaultType: "bar",
    money: true,
    ordinal: true,
  },
  {
    id: "writeOffs",
    group: "risk",
    title: "chart_writeOffs",
    dataset: "writeOffs",
    xKey: "month",
    series: [{ key: "loans", label: "chart_loans" }],
    types: ["bar", "line", "area"],
    defaultType: "bar",
  },
  {
    id: "rates",
    group: "risk",
    title: "chart_rates",
    subtitle: "chart_ratesSubtitle",
    dataset: "rates",
    xKey: "month",
    series: [
      { key: "closures_per_100", label: "chart_closuresPer100" },
      { key: "write_offs_per_100", label: "chart_writeOffsPer100" },
    ],
    types: ["line", "bar"],
    defaultType: "line",
  },
  {
    id: "closures",
    group: "risk",
    title: "chart_closures",
    dataset: "closures",
    xKey: "closure_reason",
    series: [{ key: "loan_count", label: "chart_loans" }],
    aggregateBy: "closure_reason",
    types: ["horizontalBar", "pie"],
    defaultType: "horizontalBar",
    height: 340,
  },
];

export const ANALYTICS_CHART_GROUPS = [
  { key: "volume", label: "group_volume" },
  { key: "collections", label: "group_collections" },
  { key: "risk", label: "group_risk" },
  { key: "portfolio", label: "group_portfolio" },
];

export const ANALYTICS_DATE_PRESETS = [
  { key: "thisMonth", label: "preset_thisMonth" },
  { key: "lastMonth", label: "preset_lastMonth" },
  { key: "thisQuarter", label: "preset_thisQuarter" },
  { key: "yearToDate", label: "preset_yearToDate" },
  { key: "last12Months", label: "preset_last12Months" },
];

export const ANALYTICS_KPI_TILES = [
  {
    key: "loans_disbursed",
    dataset: "disbursed",
    seriesKey: "loans_disbursed",
    label: "kpi_loansDisbursed",
    money: false,
    accent: "#2a78d6",
    tint: "#eaf2fb",
  },
  {
    key: "disbursed_amount",
    dataset: "disbursed",
    seriesKey: "disbursed_amount",
    label: "kpi_valueDisbursed",
    money: true,
    accent: "#eb6834",
    tint: "#fdf0eb",
  },
  {
    key: "capital_collected",
    dataset: "collections",
    seriesKey: "capital_collected",
    label: "kpi_capitalCollected",
    money: true,
    accent: "#1baf7a",
    tint: "#e8f7f2",
  },
  {
    key: "interest_collected",
    dataset: "collections",
    seriesKey: "interest_collected",
    label: "kpi_interestCollected",
    money: true,
    accent: "#eda100",
    tint: "#fdf6e6",
  },
  {
    key: "expense_collected",
    dataset: "expenseTotal",
    seriesKey: "expense_collected",
    label: "kpi_expensesCollected",
    money: true,
    accent: "#e87ba4",
    tint: "#fdf2f6",
  },
  {
    key: "loan_count",
    dataset: "closures",
    seriesKey: "loan_count",
    aggregatePeriods: true,
    label: "kpi_loansClosed",
    money: false,
    accent: "#4a3aa7",
    tint: "#edebf6",
  },
];

export const ANALYTICS_KPI_NEUTRAL = {
  accent: "#2b3a55",
  tint: "#eaebee",
  dataset: "activeMonthly",
  seriesKey: "active_loans",
};
export const ANALYTICS_PREFS_STORAGE_KEY = "matrices.analyticsReport.prefs";
